import React from "react";
import UxImg from "../../common/images/Uiux-services.png";
import our from "../../common/images/Our.png";
import uiuxLogo from "../../common/images/uiux-logo.png";
const HeroSection = () => {
  return (
    <section className="max-w-[1280px] mx-auto  px-5 md:px-10 ">
      <div className=" flex flex-col lg:flex-row  small:gap-10 gap-5 relative">
        <div className="img absolute -translate-x-1/2 w-[100px] md:block hidden py-10 z-10 left-[40%]">
          <img src={uiuxLogo} alt="" className="w-full" />
        </div>
        <div className="lg:w-1/2 md:py-10 py-5 md:text-center text-start lg:text-left">
          <img src={our} alt="Our Img" className="h-20 w-15" />

          <div className="flex items-center gap-5 ">
            <p className="text-black  uppercase tracking-widest font-semibold">
              Services
            </p>

            <p className="h-[3px] w-[30%] bg-[#FFC400]"></p>
          </div>
          <h1 className="text-2xl xs:text-3xl small:text-4xl lg:text-5xl font-bold text-secondary mt-2">
            UI/UX <span className="text-[#FFC400]">Design </span>
          </h1>
          <p className="text-black small:text-md text-sm mt-4 font-semibold ">
            At <b>Binary Ops Pvt Ltd</b>, we believe that great design is more
            than just aesthetics—it’s about creating a seamless and engaging
            user experience. Our expert UI/UX designers combine creativity with
            functionality to craft intuitive and visually appealing designs that
            enhance user satisfaction and drive results.
          </p>
          {/* <button className="small:mt-6 mt-3 px-10 py-2 bg-secondary text-white rounded-lg font-semibold small:text-lg text-sm hover:bg-blue-500 transition-all">
            LET’S TALK
          </button> */}
        </div>
        <div className="lg:w-1/2 md:py-10 py-0 bg-gray-50 flex justify-center relative">
          <img
            src={UxImg}
            alt="Android Development"
            className="w-full max-w-sm md:max-w-md lg:max-w-lg drop-shadow-lg"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
